import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'

const routes = [
  { // 로그인
    path: '/',
    name: 'Login',
    component: () => import('@/views/login/Login')
  },
  { // 고객관리
    path: '/customer',
    name: 'Custmer',
    component: () => import('@/views/customer/Customer')
  },
  { // 프로젝트관리
    path: '/project',
    name: 'Project',
    component: () => import('@/views/project/Project')
  },
  { // 시험관리
    path: '/study',
    name: 'Study',
    component: () => import('@/views/study/Study')
  },
  { // 시험종료관리
    path: '/study/complete',
    name: 'StudyComplete',
    component: () => import('@/views/studycomplete/StudyComplete')
  },
  { // 견적관리
    path: '/estimate',
    name: 'Estimate',
    component: () => import('@/views/estimate/Estimate')
  },
  { // KCRN
    path: '/kcrn',
    name: 'Kcrn',
    component: () => import('@/views/kcrn/Kcrn')
  },
  { // KcrnBilling
    path: '/kcrn/billing',
    name: 'KcrnBilling',
    component: () => import('@/views/kcrn/KcrnBilling')
  },
  { // 권한관리
    path: '/ecom/author',
    name: 'Author',
    component: () => import('@/views/author/Author')
  },
  { // 사용자관리
    path: '/ecom/user',
    name: 'User',
    component: () => import('@/views/user/User')
  },
  { // 프로젝트 통계
    path: '/stats/project',
    name: 'ProjectStats',
    component: () => import('@/views/stats/ProjectStats')
  },
  { // Invoice 거래처별 내역
    path: '/stats/invoice/site',
    name: 'InvoiceSite',
    component: () => import('@/views/stats/InvoiceSite')
  },
  { // 해외송금내역
    path: '/stats/out/remittance',
    name: 'OutRemittance',
    component: () => import('@/views/stats/OutRemittance')
  },
  { // 시험 통계
    path: '/stats/study',
    name: 'StudyStats',
    component: () => import('@/views/stats/StudyStats')
  },
  { // KCRN 통계
    path: '/stats/kcrn',
    name: 'KcrnStats',
    component: () => import('@/views/stats/KcrnStats')
  },
  { // 업무관리(공수) 통계
    path: '/stats/work',
    name: 'WorkStats',
    component: () => import('@/views/stats/WorkStats')
  },
  { // 결산관리 통계
    path: '/stats/balance/account',
    name: 'BalanceAccountStats',
    component: () => import('@/views/stats/BalanceAccountStats')
  },
  { // 시험매출 통계
    path: '/stats/study/sales',
    name: 'StudySalesStats',
    component: () => import('@/views/stats/StudySalesStats')
  },
  { // 원가관리
    path: '/cost',
    name: 'Cost',
    component: () => import('@/views/cost/Cost')
  },
  { // 휴일등록
    path: '/work/holiday',
    name: 'WorkHoliday',
    component: () => import('@/views/workercounting/WorkHoliday.vue')
  },
  { // 승인대상자
    path: '/work/approve/person',
    name: 'ApprovePerson',
    component: () => import('@/views/workercounting/ApprovePerson.vue')
  },
  { // 공수등록
    path: '/work/register',
    name: 'WorkRegister',
    component: () => import('@/views/workercounting/WorkRegister.vue')
  },
  { // 공수승인
    path: '/work/approve',
    name: 'WorkApprove',
    component: () => import('@/views/workercounting/WorkApprove.vue')
  },
  { // 공수조회
    path: '/work/search',
    name: 'WorkSearch',
    component: () => import('@/views/workercounting/WorkSearch.vue')
  },
  { // 부서사용자
    path: '/work/busu/person',
    name: 'BusuPerson',
    component: () => import('@/views/workercounting/BusuPerson.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/403'
  },
  {
    path: '/403',
    name: 'PageNotAuthorized',
    component: () => import('@/views/error/PageNotAuthorized')
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404'
  },
  {
    path: '/404',
    name: 'PageNotFound',
    component: () => import('@/views/error/PageNotFound')
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/500'
  },
  {
    path: '/500',
    name: 'PageServerError',
    component: () => import('@/views/error/PageServerError')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 네비게이션 가드(뷰 라우터로 URL 접근에 대해서 처리할 수 있음)
/**
 * to: 이동할 url 정보가 담긴 라우터 객체
 * from: 현재 url 정보가 담긴 라우터 객체
 * next: to에서 지정한 url로 이동하기 위해 꼭 호출해야 하는 함수
 * next() 가 호출되기 전까지 화면 전환되지 않음
 */
router.beforeEach(async (to, from, next) => {
  const publicPages = ['Login', 'PageNotFound', 'PageServerError']
  const authRequired = !publicPages.includes(to.name)

  const loggedIn = store.getters.isAuthenticated

  if (authRequired && !loggedIn) {
    router.push({ name: 'Login' })
  } else if (authRequired && loggedIn) {
    const account = store.getters.getAccount

    if (account.exp < Date.now() / 1000) {
      const refreshToken = store.getters.getRefreshToken

      if (refreshToken) {
        store.dispatch('refreshToken').then(
          () => {
            next()
          },
          () => {
            router.push({ name: 'Login' })
          }
        )
      } else {
        router.push({ name: 'Login' })
      }
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
